import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const dataSlice = createSlice({
  name: "add-model-to-theme",
  initialState: initialState,
  reducers: {
    initAddModelToTheme: () => {
      return { ...initialState };
    },
    startAddModelToTheme: (state) => {
      state.loading = true;
    },
    successAddModelToTheme: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorAddModelToTheme: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initAddModelToTheme,
  startAddModelToTheme,
  successAddModelToTheme,
  errorAddModelToTheme,
} = dataSlice.actions;

export default dataSlice.reducer;
